import React from "react";
import { X, Instagram, Youtube } from "lucide-react";
import "../styles/SocialLinks.css";

interface SocialLinksProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SocialLinks = ({ isOpen, onClose }: SocialLinksProps) => {
  if (!isOpen) return null;

  return (
    <div className="social-modal-overlay" onClick={onClose}>
      <div
        className="social-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="social-modal-close" onClick={onClose}>
          <X size={20} />
        </button>

        <h3 className="social-modal-title">Follow Us</h3>

        <div className="social-icons-row">
          <a
            href="https://www.instagram.com/augio.io"
            target="_blank"
            rel="noreferrer"
            className="social-icon-btn"
          >
            <Instagram size={24} />
          </a>

          {/*
          <a
            href="https://www.tiktok.com/@augio.io"
            target="_blank"
            rel="noreferrer"
            className="social-icon-btn"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
            </svg>
          </a>
          */}

          <a
            href="https://www.youtube.com/@Augio-io/featured"
            target="_blank"
            rel="noreferrer"
            className="social-icon-btn"
          >
            <Youtube size={24} />
          </a>
        </div>
      </div>
    </div>
  );
};
